// All values are inlined at build time via webpack DefinePlugin. The fallbacks
// keep tests/typecheck happy when running outside the webpack pipeline.
export const API_URL = process.env.BLEINKS_API_URL ?? 'https://api.bleinks.com';
export const APP_URL = process.env.BLEINKS_APP_URL ?? 'https://app.bleinks.com';
export const ADDIN_URL = process.env.BLEINKS_ADDIN_URL ?? 'https://addin.bleinks.com';
export const FIREBASE_API_KEY = process.env.BLEINKS_FIREBASE_API_KEY ?? '';
export const FIREBASE_AUTH_DOMAIN = process.env.BLEINKS_FIREBASE_AUTH_DOMAIN ?? '';
export const FIREBASE_PROJECT_ID = process.env.BLEINKS_FIREBASE_PROJECT_ID ?? '';
export const FIREBASE_APP_ID = process.env.BLEINKS_FIREBASE_APP_ID ?? '';
export const FIREBASE_MESSAGING_SENDER_ID = process.env.BLEINKS_FIREBASE_MESSAGING_SENDER_ID ?? '';
export const FIREBASE_STORAGE_BUCKET = process.env.BLEINKS_FIREBASE_STORAGE_BUCKET ?? '';
export const TAG_TYPES = {
    SIGN: { label: 'Signature', icon: '✍', minWidth: 150, minHeight: 50 },
    DATE: { label: 'Date', icon: '📅', minWidth: 100, minHeight: 25 },
    INITIALS: { label: 'Initials', icon: '✒', minWidth: 60, minHeight: 40 },
    TEXT: { label: 'Text', icon: 'T', minWidth: 100, minHeight: 25 },
    NAME: { label: 'Name', icon: '👤', minWidth: 120, minHeight: 25 },
    EMAIL: { label: 'Email', icon: '✉', minWidth: 150, minHeight: 25 },
};
export const SIGNER_COLOURS = [
    { bg: '#DBEAFE', border: '#1f74f2', label: 'Blue' },
    { bg: '#D1FAE5', border: '#10B981', label: 'Green' },
    { bg: '#FEF3C7', border: '#F59E0B', label: 'Amber' },
    { bg: '#EDE9FE', border: '#8B5CF6', label: 'Purple' },
    { bg: '#FCE7F3', border: '#EC4899', label: 'Pink' },
];
export const TIER_LIMITS = {
    free: { documentsPerMonth: 3, signersPerDoc: 1, templates: 1 },
    pro: { documentsPerMonth: Infinity, signersPerDoc: 4, templates: Infinity },
    business: { documentsPerMonth: Infinity, signersPerDoc: 10, templates: Infinity },
};
